import React, { ReactElement } from "react";

import { ContentSource } from "../../../common/types/ContentSource";
import { ContentSourcesBadge } from "../components/ContentSourcesBadge";

export const renderContentSources = <
    T extends { includedSources: ContentSource[]; orphaned: boolean; orphanedDetails: string[] }
>(
    item?: T
): ReactElement | null => {
    if (!item) return null;

    const showOrphanedDetails = item.orphaned && !item.includedSources.includes(ContentSource.Sprint);

    return (
        <ContentSourcesBadge
            sources={item.includedSources}
            tooltipContent={showOrphanedDetails ? item.orphanedDetails.join("\n\n") : undefined}
        />
    );
};

export const renderContentSource = <T extends { source: ContentSource }>(item?: T): ReactElement | null => {
    if (!item) return null;

    return <ContentSourcesBadge sources={[item.source]} />;
};
